import React from 'react';
import {getMessage} from "./util";

const TopProjectsTable = ({ questions, district }) => {
    const getTopProjects = () => {
        if (!questions || questions.length === 0) {
            return [];
        }

        const filteredQuestions = questions.filter((question) => {
            const questionNumber = parseInt(question.question_id.replace('Q', ''));
            return questionNumber >= 1 && questionNumber <= 13;
        });

        const projectsWithVotes = filteredQuestions.flatMap((question) => {
            const districtData = district
                ? question.districts.find(d => d.district_id === district.id)
                : null;

            const choices = districtData && Array.isArray(districtData.choices)
                ? districtData.choices
                : question.choices;

            return (Array.isArray(choices) ? choices : []).map((choice) => {
                const totalVotes = districtData
                    ? (districtData.choices && districtData.choices[choice.absolute_position]) || 0
                    : question.totals[choice.absolute_position] || 0;

                return {
                    name: choice.name,
                    total: totalVotes
                };
            });
        });

        // Ordenar por la cantidad de votos y devolver los primeros 5 (o aquellos que tengan la misma cantidad de votos que el nro 5)
        return (() => {
            const sortedProjects = projectsWithVotes.sort((a, b) => b.total - a.total);
            const topFive = sortedProjects.slice(0, 5);
            const fifthProjectVotes = topFive[4] ? topFive[4].total : 0;

            // Filtrar proyectos que tengan la misma cantidad de votos que el quinto
            const allMatchingProjects = sortedProjects.filter(project => project.total === fifthProjectVotes);

            // Combinar los primeros cinco con los proyectos coincidentes, asegurando que no haya duplicados
            return [...new Set([...topFive, ...allMatchingProjects])];
        })();
    };

    const topProjects = getTopProjects();

    return (
        <div className="row mt-4">
            <div className="table-responsive">
                <table className="table table-bordered  table-hover  rounded">
                    <thead>
                    <tr>
                        <th colSpan="2" className="EvColorGrisLight">

                            PROYECTOS REGIONALES MÁS VOTADOS

                        </th>
                    </tr>
                    <tr>
                        <th>Nombre del Proyecto</th>
                        <th>Total de Votos</th>
                    </tr>
                    </thead>
                    <tbody>
                    {topProjects.length > 0 ? (
                        topProjects.map((project, index) => (
                            <tr key={index}>
                                <td>{project.name}</td>
                                <td>
                                    {project.total.toLocaleString(navigator.language, {
                                        maximumFractionDigits: 0,
                                        minimumFractionDigits: 0,
                                    })}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="2" className="text-center">
                                No hay proyectos disponibles para este distrito.
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default TopProjectsTable;
